import ButtonControl from '../button-control'
import Panel from '../panel'
import AppliedFilter from './AppliedFilter'
import CategorySelector from './CategorySelector'
import AuthorSelector from './AuthorSelector'
import Icon from '../assets'
import SearchBox from '../search-box/SearchBox'
import PillContainer from '../pills/PillContainer'
import Pill from '../pills/Pill'
import PublicLabelSelector from './PublicLabelSelector'

const ArticlesOverviewFilters = ({ categories, labels, authors, filters, onFilterChange, onClearFilterCriteria }) => {
  let appliedFilters = []
  Object.keys(filters).forEach(key => filters[key].length && appliedFilters.push(filters[key][0]))
  const areFiltersApplied = appliedFilters.length > 0
  return (
    <div>
      <Panel>
        <div class='articles-overview__filters-container'>
          <CategorySelector
            items={categories}
            selected={filters.category[0] && { type: 'category', name: filters.category[0].name }}
            onFilterChange={(e) => onFilterChange('category', [{ id: e.target.getAttribute('value'), name: e.target.textContent, type: 'category' }])}
          />
          <PublicLabelSelector
            labels={labels}
            selected={filters.label[0] && { type: 'label', name: filters.label[0].name }}
            onFilterChange={(e) => onFilterChange('label', [{ id: e.target.getAttribute('value'), name: e.target.getAttribute('value'), type: 'label' }])}
          />
          <AuthorSelector
            authors={authors}
            selected={filters.author[0] && { type: 'author', name: filters.author[0].name }}
            onFilterChange={(e) => onFilterChange('author', [{ id: e.target.getAttribute('value'), name: e.target.textContent, type: 'author' }])}
          />
          <SearchBox
            value={filters.search[0] && filters.search[0].name}
            placeholder='Search in title and content'
            onSubmit={(value) => onFilterChange('search', [{ id: value, name: value, type: 'search' }])} />
        </div>
      </Panel>
      {
        areFiltersApplied &&
          <PillContainer>
            {
              appliedFilters.map(({ type, name }) =>
                <Pill>
                  <AppliedFilter type={type} name={name} />
                  <Icon customClass={`qa-dismiss-${type}-filter-pill`} icon='close' width='16' height='16' onClick={() => onFilterChange(type, [])} />
                </Pill>
              )
            }
            <ButtonControl
              class='articles-overview__filters-clear'
              title='Clear selection'
              variant='warning'
              onClick={onClearFilterCriteria}
            />
          </PillContainer>
      }
    </div>
  )
}

export default ArticlesOverviewFilters
